import { Button } from "components/styledComponents/Button";
import { useApi } from "../../../hooks/useApi";
import { pick } from "lodash";
import { useState } from "react";
import useSWR from "swr";
import { SpaceBooking, SpaceGroup } from "../types";
import { BookingForm } from "./SpaceBookingAssistant";

interface PropsWithBooking {
    bookingId?: number;
    booking: SpaceBooking;
    clubSlug: string;
    callback?: (updatedBooking: SpaceBooking) => void;
}

interface PropsWithBookingID {
    bookingId: number;
    booking?: SpaceBooking;
    clubSlug: string;
    callback?: (updatedBooking: SpaceBooking) => void;
}

type Props = (PropsWithBooking | PropsWithBookingID) & { adminMode?: boolean };

export const SpaceBookingEditForm = ({
    booking: _booking,
    bookingId: _bookingId,
    adminMode,
    clubSlug,
    callback = () => {},
}: Props) => {
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const bookingId = _bookingId || _booking?.id;
    const {
        data,
        isLoading: isLoadingSpaceBooking,
        mutate,
    } = useSWR<{ data: SpaceBooking }>(bookingId ? `space/booking/${bookingId}` : null);
    const {
        data: spaceGroupData,
        isLoading: isLoadingSpaceGroup,
        mutate: mutateSpaceGroup,
    } = useSWR<{ data: SpaceGroup }>(data?.data.space_group_id ? `space/group/${data?.data.space_group_id}` : null);
    const isLoadingData = bookingId && (isLoadingSpaceBooking || isLoadingSpaceGroup);
    const booking = data?.data;

    const handleCallback = (data) => {
        setIsLoading(true);
        api({
            url: `space/booking/${booking.id}`,
            method: "PUT",
            data: {
                ...pick(data, [
                    "start",
                    "start_time",
                    "end_time",
                    "fellows",
                    "repeat_period",
                    "repeat_until",
                    "exemptions",
                    "notify_user",
                ]),
                spaces: data.spaces.map((space) => space.id),
            },
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => {
                mutate();
                mutateSpaceGroup();
                callback(data);
            },
        });
    };

    const handelCancelBooking = () => {
        setIsLoading(true);
        api({
            url: `space/booking/${booking.id}/cancel`,
            method: "POST",
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback(data),
        });
    };

    return isLoadingData ? (
        <div>Lade ...</div>
    ) : (
        <>
            <Button isLoading={isLoading} onClick={handelCancelBooking} variant="danger" className="w-100 mb-3">
                Buchung stornieren
            </Button>
            <BookingForm
                editMode
                adminMode={adminMode}
                showFellows={data?.data.fellows_editable}
                isLoading={isLoading}
                clubSlug={clubSlug}
                spaceGroup={spaceGroupData?.data}
                booking={booking}
                callback={handleCallback}
            />
        </>
    );
};
